import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { MessageBoxImageDialogComponent } from './message-box-image/message-box-image-dialog.component';
import { MessageBoxComponent } from './message-box.component';

@NgModule({
    imports: [
        CommonModule,
        MatIconModule,
        FlexLayoutModule,
    ],
    declarations: [
        MessageBoxComponent,
        MessageBoxImageDialogComponent
    ],
    exports: [
        MessageBoxComponent,
    ]
})
export class MessageBoxModule {
}
